// eslint-disable-next-line no-control-regex -- intentionally rejecting control characters in filenames
export const ALLOWED_FILENAME_CHARS_REGEX = /^(?!\s*$)[^/\\\x00-\x1F\x7F]+$/
